const searchInput = document.querySelector('[data-serach-open-input]')

const hideSearch = () => {
  document.documentElement.classList.remove('in-search')
}
if (searchInput) {
  ['input', 'click'].forEach(function(e) {
    searchInput.addEventListener(e, () => {
      document.documentElement.classList.add('in-search')
      searchInput.dispatchEvent(new Event('open', { bubbles: true }))
      window.addEventListener('scroll', hideSearch, { once: true })
    });
  });
  document.addEventListener('click', (event) => {
    if (
      !event.target.closest('.search-panel') &&
      event.target !== searchInput
    ) {
      hideSearch()
      window.removeEventListener('scroll', hideSearch)
    }
  })
}
